import logoWhite from 'app/assets/images/Logo_Deliveree_White.svg'
// Deliveree
import logoTransportifyWhite from 'app/assets/images/Logo_Transportify_White.svg'
import iconLogout from 'app/assets/images/Logout.svg'
import pdfIconChat from 'app/assets/images/chat/PDF.svg'
import disabledIconChat from 'app/assets/images/chat/icon-chat-disabled.svg'
import locatingGif from 'app/assets/images/chat/icon-rolling.svg'
// Chat
import emptyIconChat from 'app/assets/images/chat/icon_chat_batch.png'
import textIcon from 'app/assets/images/chat/text-icon.svg'
import wordIconChat from 'app/assets/images/chat/word.svg'
import contactDescription from 'app/assets/images/contact/icon-location-detail.svg'
import contactPhone from 'app/assets/images/contact/icon-phone.svg'
// Contact
import contactUser from 'app/assets/images/contact/icon-user.svg'
import iconDoneDevina from 'app/assets/images/deliveree/Check-done.svg'
import iconWarningDevina from 'app/assets/images/deliveree/Warning.svg'
// devina
import devinaIcon from 'app/assets/images/deliveree/devina-icon.png'
import iconBatchNeedConfirm from 'app/assets/images/deliveree/icon-batch-need-confirm.png'
import iconPartialLoadWhite from 'app/assets/images/icon-partial-load-white.png'
import iconPersonal from 'app/assets/images/icon-personal.svg'
import iconGoogle from 'app/assets/images/lcl/icons-google.svg'
import bubbleEta from 'app/assets/images/live_tracking/bubble-eta.svg'
import cancelHeaderIcon from 'app/assets/images/live_tracking/cancel.svg'
import driverMarker from 'app/assets/images/live_tracking/driver-marker.svg'
import editHeaderIcon from 'app/assets/images/live_tracking/edit.svg'
import iconQuote from 'app/assets/images/live_tracking/icon-quote.svg'
import infoBoxYellow from 'app/assets/images/live_tracking/info-box-yellow.png'
// social
import iconFacebook from 'app/assets/images/social/facebook-icon.png'
import uploadImage from 'app/assets/images/upload-image.svg'

import defaultAvatar from '../../assets/images/avatar/default-avatar.jpg'
import computerBatchIcon from '../../assets/images/computer-batch-icon.png'
import duplicateGray from '../../assets/images/duplicate-gray.svg'
import duplicateGreen from '../../assets/images/duplicate-green.svg'
import excelBatchIcon from '../../assets/images/excel-icon.png'
import mapIconLoadPlan from '../../assets/images/final-leo-graphic.png'
import flagENIcon from '../../assets/images/flags/en.png'
import flagIDIcon from '../../assets/images/flags/id.png'
import flagPHIcon from '../../assets/images/flags/philippines.svg'
import flagTHIcon from '../../assets/images/flags/thailand.svg'
import flagVNIcon from '../../assets/images/flags/vietnam.svg'
import iconFromBlue from '../../assets/images/from-blue.svg'
import iconFromGreen from '../../assets/images/from-green.svg'
// Create Listing
import addAnotherItem from '../../assets/images/icons/add-another-item.png'
import arrowUpRight from '../../assets/images/icons/arrow-up-right.svg'
import dateEvent from '../../assets/images/icons/calendar.svg'
import iconDelivereeGreen from '../../assets/images/icons/icon-deliveree-green.svg'
import iconDelivereeWhite from '../../assets/images/icons/icon-deliveree-white.svg'
import iconDetails from '../../assets/images/icons/icon-details.svg'
import infoIcon from '../../assets/images/icons/icon-info.svg'
import iconOSA from '../../assets/images/icons/icon-osa.svg'
import iconTransportifyGreen from '../../assets/images/icons/icon-transportify-green.svg'
import iconTransportifyWhite from '../../assets/images/icons/icon-transportify-white.svg'
import plusIcon from '../../assets/images/icons/plus.png'
import timeAccess from '../../assets/images/icons/time-access.svg'
import v2LogoWhite from '../../assets/images/lcl/Logo_Deliveree_White.svg'
import v2LogoWhiteTransportify from '../../assets/images/lcl/Logo_Transportify_White.svg'
import addressDetailIcon from '../../assets/images/lcl/address-detail.svg'
import locationAddressIcon from '../../assets/images/lcl/address.svg'
import anchorIcon from '../../assets/images/lcl/anchor.svg'
import arrowDown from '../../assets/images/lcl/arrow-down.svg'
import arrowUp from '../../assets/images/lcl/arrow-up.svg'
import bitmap from '../../assets/images/lcl/bitmap.png'
import bitmapWithoutRadian from '../../assets/images/lcl/bitmap_without_radian.png'
import bookmarkedIconActive from '../../assets/images/lcl/bookmarked-active.svg'
import bookmarkedIcon from '../../assets/images/lcl/bookmarked.svg'
import callWhiteIcon from '../../assets/images/lcl/call-white.svg'
import carIcon from '../../assets/images/lcl/car-icon.svg'
import chatWhiteIcon from '../../assets/images/lcl/chat-white.svg'
import closeIcon from '../../assets/images/lcl/close.svg'
import locationCompanyIcon from '../../assets/images/lcl/company.svg'
import currentLocation from '../../assets/images/lcl/current-location.svg'
import deliveryBookingCanceled from '../../assets/images/lcl/delivery_booking_canceled.svg'
import deliveryBookingCompleted from '../../assets/images/lcl/delivery_booking_completed.svg'
import duplicateIcon from '../../assets/images/lcl/duplicate.svg'
import iconEditLocations from '../../assets/images/lcl/edit-icon.svg'
import iconEdit from '../../assets/images/lcl/edit.svg'
import locationEmailIcon from '../../assets/images/lcl/email.svg'
import goodsIcon from '../../assets/images/lcl/goods.svg'
import goodsBubbleIcon from '../../assets/images/lcl/goodsBubble.svg'
import iconArrowError from '../../assets/images/lcl/icon-arrow-error.svg'
import checkIcon from '../../assets/images/lcl/icon-check.svg'
import copyBookingIcon from '../../assets/images/lcl/icon-copy.svg'
import iconDriverBan from '../../assets/images/lcl/icon-driver-ban.svg'
import iconDriverFavorite from '../../assets/images/lcl/icon-driver-favorite.svg'
import iconEpod from '../../assets/images/lcl/icon-epod.svg'
import leftIcon from '../../assets/images/lcl/icon-left.svg'
import longHaulGrayIcon from '../../assets/images/lcl/icon-long-haul-dark.svg'
import supportIcon from '../../assets/images/lcl/icon-support.svg'
import closeTrackingIcon from '../../assets/images/lcl/icon-tracking-close.svg'
import vesselIcon from '../../assets/images/lcl/icon-vessel.svg'
import iconWarning from '../../assets/images/lcl/icon-warning.svg'
import iconAdd from '../../assets/images/lcl/icon_add.png'
import invalidLink from '../../assets/images/lcl/invalid_link.svg'
import locationIcon from '../../assets/images/lcl/location.svg'
import mask from '../../assets/images/lcl/mask.svg'
import missingImage from '../../assets/images/lcl/missing-image.png'
import locationNameIcon from '../../assets/images/lcl/name.svg'
import noScheduleIcon from '../../assets/images/lcl/no-schedule.svg'
import locationNumberIcon from '../../assets/images/lcl/number.svg'
import paySuccess from '../../assets/images/lcl/paid-stamp.svg'
import pendingBookedIcon from '../../assets/images/lcl/pending-booked.svg'
import phoneTracking from '../../assets/images/lcl/phone-tracking.svg'
import playStoreAndroid from '../../assets/images/lcl/play_store_android.svg'
import playStoreIOS from '../../assets/images/lcl/play_store_ios.svg'
import portFrom from '../../assets/images/lcl/port-from.svg'
import portTo from '../../assets/images/lcl/port-to.svg'
import saveLocation from '../../assets/images/lcl/save-location.svg'
import shipIcon from '../../assets/images/lcl/ship-icon.svg'
import shutterStock from '../../assets/images/lcl/shutter_stock.svg'
import iconNotRequiredSignatureEn from '../../assets/images/lcl/signature-not-required-EN.png'
import iconNotRequiredSignatureId from '../../assets/images/lcl/signature-not-required-ID.png'
import iconSpil from '../../assets/images/lcl/spill-flag.webp'
import locationTitleIcon from '../../assets/images/lcl/title.svg'
import trashIcon from '../../assets/images/lcl/trash.svg'
import vesselBigIcon from '../../assets/images/lcl/vessel-big-icon.svg'
import moreHorizGreen from '../../assets/images/more-horiz-green.svg'
// popup
import popupIconAttached from '../../assets/images/popup/002-attached.svg'
import removeGray from '../../assets/images/remove-gray.svg'
import removeRed from '../../assets/images/remove-red.svg'
import iconToGreen from '../../assets/images/to-green.svg'
import iconToYellow from '../../assets/images/to-yellow.svg'
import iconTriangleWarning from '../../assets/images/triangle-warning-icon.png'
import verticalAlignBottom from '../../assets/images/vertical-align-bottom.svg'

// Flags
export const ICON_FLAG_VN = flagVNIcon
export const ICON_FLAG_PH = flagPHIcon
export const ICON_FLAG_ID = flagIDIcon
export const ICON_FLAG_TH = flagTHIcon
export const ICON_FLAG_EN = flagENIcon

// Common
export const DATE_EVENT = dateEvent
export const TIME_ACCESS = timeAccess
export const MORE_HORIZ_GREEN = moreHorizGreen
export const DUPLICATION_GREEN = duplicateGreen
export const DUPLICATION_GRAY = duplicateGray
export const REMOVE_RED = removeRed
export const VERTICAL_ALIGN_BOTTOM = verticalAlignBottom
export const ICON_FROM_BLUE = iconFromBlue
export const ICON_FROM_GREEN = iconFromGreen
export const ICON_TO_YELLOW = iconToYellow
export const ICON_TO_GREEN = iconToGreen
export const UPLOAD_IMAGE = uploadImage
export const ICON_LOGOUT = iconLogout
export const ICON_PERSONAL = iconPersonal
export const COMPUTER_BATCH_ICON = computerBatchIcon
export const EXCEL_BATCH_ICON = excelBatchIcon
export const MAP_ICON_LOAD_PLAN = mapIconLoadPlan
export const GOODS_ICON = goodsIcon
export const GOODS_BUBBLE_ICON = goodsBubbleIcon
export const ADD_ANOTHER_ITEM = addAnotherItem
export const ICON_PARTIAL_LOAD_WHITE = iconPartialLoadWhite
export const ICON_TRIANGLE_WARNING = iconTriangleWarning
// Deliveree
export const LOGO_WHITE = logoWhite
export const LOGO_TRANSPORTIFY_WHITE = logoTransportifyWhite
export const ICON_TRANSPORTIFY_WHITE = iconTransportifyWhite
export const ICON_DELIVEREE_WHITE = iconDelivereeWhite
export const ICON_TRANSPORTIFY_GREEN = iconTransportifyGreen
export const ICON_DELIVEREE_GREEN = iconDelivereeGreen
export const DEFAULT_AVATAR = defaultAvatar

export const ICON_SPIL = iconSpil

// popup
export const POPUP_ICON_ATTACHED = popupIconAttached
export const ICON_OSA = iconOSA

// for Devina
export const DEVINA_ICON = devinaIcon
export const ICON_WARNING_DEVINA = iconWarningDevina
export const ICON_DONE_DEVINA = iconDoneDevina

export const ICON_BATCH_NEED_CONFIRM = iconBatchNeedConfirm

// Chat
export const PDF_ICON_CHAT = pdfIconChat
export const WORD_ICON_CHAT = wordIconChat
export const TEXT_ICON = textIcon
export const LOCATING_GIF = locatingGif
export const EMPTY_ICON_CHAT = emptyIconChat
export const DISABLED_ICON_CHAT = disabledIconChat

// Contact
export const CONTACT_USER = contactUser
export const CONTACT_PHONE = contactPhone
export const CONTACT_DESCRIPTION = contactDescription

// live tracking
export const ICON_QUOTE = iconQuote
export const BUBBLE_ETA = bubbleEta
export const DRIVER_MARKER = driverMarker
export const INFO_BOX_YELLOW = infoBoxYellow
export const CANCEL_HEADER_ICON = cancelHeaderIcon
export const EDIT_HEADER_ICON = editHeaderIcon

// social
export const ICON_FACEBOOK = iconFacebook
export const ICON_GOOGLE = iconGoogle
//lcl
export const ARROW_DOWN_ICON = arrowDown
export const ARROW_UP_ICON = arrowUp

export const CURRENT_LOCATION_ICON = currentLocation
export const SAVE_LOCATION_ICON = saveLocation
export const NO_SCHEDULE_ICON = noScheduleIcon
export const PORT_FROM = portFrom
export const PORT_TO = portTo
export const CLOSE_ICON = closeIcon
export const ICON_EDIT_LOCATIONS = iconEditLocations
export const ICON_EDIT = iconEdit
export const LONG_HAUL_GRAY_ICON = longHaulGrayIcon
export const LOCATION_NAME_ICON = locationNameIcon
export const LOCATION_ADDRESS_ICON = locationAddressIcon
export const LOCATION_NUMBER_ICON = locationNumberIcon
export const LOCATION_TITLE_ICON = locationTitleIcon
export const LOCATION_EMAIL_ICON = locationEmailIcon
export const LOCATION_COMPANY_ICON = locationCompanyIcon
export const TRASH_ICON = trashIcon
export const ADDRESS_DETAIL_ICON = addressDetailIcon
export const LOCATION_ICON = locationIcon
export const CALL_WHITE_ICON = callWhiteIcon
export const CHAT_WHITE_ICON = chatWhiteIcon
export const PENDING_BOOKED_ICON = pendingBookedIcon
export const SUPPORT_ICON = supportIcon
export const LEFT_ICON = leftIcon
export const DUPLICATE_ICON = duplicateIcon
export const BOOKMARKED_ICON = bookmarkedIcon
export const BOOKMARKED_ICON_ACTIVE = bookmarkedIconActive
export const COPY_BOOKING_ICON = copyBookingIcon
export const PHONE_TRACKING_ICON = phoneTracking
export const ANCHOR_ICON = anchorIcon
export const CHECK_ICON = checkIcon
export const VESSEL_ICON = vesselIcon
export const VESSEL_BIG_ICON = vesselBigIcon
export const CAR_ICON = carIcon
export const CLOSE_TRACKING_ICON = closeTrackingIcon
export const SHIP_ICON = shipIcon
export const ICON_PLAY_STORE_ANDROID = playStoreAndroid
export const ICON_PLAY_STORE_IOS = playStoreIOS
export const INVALID_LINK = invalidLink
export const BG_BITMAP_WITHOUT_RADIAN = bitmapWithoutRadian
export const V2_LOGO_WHITE_TRANSPORTIFY = v2LogoWhiteTransportify
export const V2_LOGO_WHITE = v2LogoWhite
export const ICON_SHUTTLE_STOCK = shutterStock
export const BG_BITMAP = bitmap
export const ICON_DELIVERY_BOOK_COMPLETED = deliveryBookingCompleted
export const ICON_DELIVERY_BOOK_CANCELED = deliveryBookingCanceled
export const ICON_DETAILS = iconDetails
export const PLUS_ICON = plusIcon
export const PAY_SUCCESS = paySuccess
export const ICON_DRIVER_BAN = iconDriverBan
export const ICON_DRIVER_FAVORITE = iconDriverFavorite
export const MASK = mask
export const ICON_ADD = iconAdd
export const MISSING_IMAGE = missingImage
export const REMOVE_GRAY = removeGray
export const ICON_WARNING = iconWarning
export const INFO_ICON = infoIcon
export const ICON_ARROW_ERROR = iconArrowError
export const ICON_NOT_REQUIRED_SIGNATURE_EN = iconNotRequiredSignatureEn
export const ICON_NOT_REQUIRED_SIGNATURE_ID = iconNotRequiredSignatureId
export const ICON_EPOD = iconEpod
export const ARROW_UP_RIGHT = arrowUpRight
